import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

const styles = {
  dialogTitle: {
    position: "relative",
    textAlign: "center",
    pb: 1,
  },
  closeIcon: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  errorTitle: {
    color: "error.main",
    fontSize: 24,
    fontWeight: 500,
  },
  dialogContent: {
    textAlign: "center",
    p: 4,
  },
  errorMessage: {
    fontSize: 18,
    lineHeight: 1.4,
  },
};

export default function ValidationErrorModal({ onClose }) {
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={styles.dialogTitle}>
        <Typography sx={styles.errorTitle}>Error</Typography>
        <IconButton onClick={onClose} sx={styles.closeIcon}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography sx={styles.errorMessage}>
          Please fill out all required information before duplicating.
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
